import React, { useCallback, useEffect, useState } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import noop from 'lodash/noop';
import { getIsOfferCheckLoadingOverlayVisible } from 'modules/alternativeOffers/selectors';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Overlay } from '@daedalus/atlas/Overlay';
import { Text } from '@daedalus/atlas/Text';
import vioGif from '@daedalus/shared/src/authentication/CognitoPasswordlessLoader/vio.gif';
const _exp = /*#__PURE__*/() => Flex.Column;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "w104vacu",
  propsAsIs: true
});
const LoadingImage = /*#__PURE__*/styled('img')({
  name: "LoadingImage",
  class: "lfjk9b",
  propsAsIs: false
});
const overlayContainerStyles = "o14pmra4";
const loadingMessages = [defineMessage({
  id: 'offerCheck.availability',
  defaultMessage: 'Checking availability...'
}), defineMessage({
  id: 'offerCheck.confirming',
  defaultMessage: 'Confirming your deal...'
}), defineMessage({
  id: 'df.loadingAlmostThere',
  defaultMessage: 'Almost there...'
}), defineMessage({
  id: 'df.loadingStillWorkingOnIt',
  defaultMessage: 'Still working on it...'
})];
const INTERVAL_TIMEOUT = 8000;
const LoadingIndicator = ({
  intervalTimeout
}: {
  intervalTimeout: number;
}) => {
  const {
    formatMessage
  } = useIntl();
  const [currentMessage, setCurrentMessage] = useState(0);
  const next = useCallback(() => {
    setCurrentMessage(value => {
      const nextValue = value + 1;
      // loop between last message and second last message
      return nextValue === loadingMessages.length ? nextValue - 2 : nextValue;
    });
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, intervalTimeout);
    return () => {
      clearInterval(interval);
    };
  }, [next, intervalTimeout]);
  return <Wrapper alignItems="center" justifyContent="center">
      <LoadingImage src={vioGif} alt={formatMessage({
      id: 'loading',
      defaultMessage: 'Loading...'
    })} />
      <Text variant="titleM">
        {formatMessage(loadingMessages[currentMessage])}
      </Text>
    </Wrapper>;
};
export const OfferCheckLoadingOverlay = ({
  intervalTimeout = INTERVAL_TIMEOUT
}: {
  intervalTimeout?: number;
}) => {
  const isOpen = useSelector(getIsOfferCheckLoadingOverlayVisible);
  return <Overlay isOpen={isOpen} animationType={isOpen ? 'overlayFade' : 'none'} shadeBackground onShadeBackgroundClick={noop} customStyles={overlayContainerStyles}>
      <LoadingIndicator intervalTimeout={intervalTimeout} />
    </Overlay>;
};

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");